import Vue from 'vue'
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';

const contractInfo = require('./rewardPoolContract.json')

let web3 = $web3js.getWeb3();

let contractAddress = $bizConfig.rewardPoolContractAddress;
let contractConst = {
  contract: web3 ? new web3.eth.Contract(contractInfo.abi, contractAddress) : '',
}

const getRewardPoolAddress = () => {
  return contractAddress;
}

const getRewardPoolContract = () => {
  return contractConst.contract;
}

const getRewardPoolUserInfo = ([_pid, _user], options) => {
  let dmcAddress = $erc20.getErc20Address("DMC");
  return $web3js.call(getRewardPoolContract().methods.getUserInfo, [_pid, _user, dmcAddress], options, handleRewardPoolUserInfo);
}

const handleRewardPoolUserInfo = async (res) => {
  // console.log(res)
  let index = 0;
  let amount = res[index++];
  let reward = res[index++];
  let lpToken = res[index++];

  amount = await $erc20.fromErc20Value(amount, lpToken);
  reward = Vue.prototype.$numberUtils.movePointLeft(reward, 18);

  return {
    amount,
    reward,
    lpToken,
  }
}


export default {
  getRewardPoolAddress,
  getRewardPoolContract,
  getRewardPoolUserInfo
}


// WEBPACK FOOTER //
// ./src/lib/contract/rewardPool/index.js